export default {
  handleFormValidation() {
    const oForm = $("#form-manifiesto");

    const aRules = {
      manifiesto: {
        required: true
      },
      nave_id: {
        required: true
      },
      aduana_codigo: {
        required: true
      },
      eta: {
        required: true
      }
    };

    const aMessages = {
      manifiesto: {
        required: "El campo Manifiesto es obligatorio."
      },
      nave_id: {
        required: "El campo Nave es obligatorio."
      },
      aduana_codigo: {
        required: "El campo Aduana es obligatorio."
      },
      eta: {
        required: "El campo ETA es obligatorio."
      }
    };

    // Validación del formulario
    FormHelper.validate(oForm, aRules, aMessages);
  },

  initDatePickers() {
    $(".js-datepicker").datepicker({
      orientation: "left",
      autoclose: true,
      format: "dd/mm/yyyy",
      language: "es"
    });
  },

  initCombos() {
    $('#cmbAduanas').change(function () {
      const codigoAduana = $(this).val();
      const $comboPuertos = $('#cmbPuertos');

      $comboPuertos.empty();

      if (!codigoAduana) {
        return;
      }

      $.ajax("/api/aduana/" + codigoAduana + '/puertos', {
        method: "GET",
        success: response => {
          if (response.success) {
            $comboPuertos.append("<option value=''></option>");

            response.data.forEach(puerto => {
              const $option = $(
                `<option value='${puerto.id}'>${puerto.nombre}</option>`
              );

              $comboPuertos.append($option);
            });
          }
        },
        error: err => {
          Notificaciones.showToastr(
            "Ups!",
            "No pudimos obtener la acción deseada. Nuestro equipo ha sido notificado.",
            "error"
          );

          throw new Error(
            `Error al obtener los Puertos de la Aduana Cod. ${codigoAduana}: ${err.responseText}`
          );
        }
      });
    });

    $(".select2").select2({
      placeholder: "Seleccionar...",
      allowClear: true
    });
  },

  initAsociarManifiestos() {
    $('.js-update-manifiesto-despacho')
      .keyup(function () {
        this.value = this.value.replace(/\s+/g, '');
      })
      .change(function () {
        const $input = $(this);
        const manifiesto = $input.val();
        const despacho = $input.data('despacho');

        $.ajax("/api/di/" + despacho + '/asociar/manifiesto', {
          method: "POST",
          data: {
            _method: "PATCH",
            manifiesto: manifiesto
          },
          success: function (response) {
            const data = response.data;

            if (response.success) {
              if (data.fecha_incorporacion_manifiesto || data.numero_manifiesto === null) {
                $('.js-despacho-' + despacho + '.js-fecha-incorporacion-manifiesto')
                  .html(data.fecha_incorporacion_manifiesto);
              }

              $input.parent()
                .removeClass('has-error')
                .addClass('has-success');

              setTimeout(async function () {
                $input.parent().removeClass('has-success');
              }, 2500);
            } else {
              Notificaciones.showToastr(
                "Ups!",
                "El manifiesto proporcionado no existe. Por favor, cree el manifiesto y vuelva a intentarlo.",
                "error"
              );

              $input.focus();
              $input.select();
              $input.parent().addClass('has-error');
            }
          },
          error: err => {
            Notificaciones.showToastr(
              "Ups!",
              "No pudimos completar la acción deseada. Nuestro equipo ha sido notificado.",
              "error"
            );

            throw new Error(
              `Error al asociar manifiesto '${manifiesto}' al despacho ${despacho}: ${err.responseText}`
            );
          }
        });
      })
  },

  init() {
    this.initCombos();
    this.initDatePickers();
    this.handleFormValidation();
  },

  initIndex() {
    this.initCombos();
    this.initDatePickers();

    FormHelper.handleSearch();
    FormHelper.handleOrderBy();
    FormHelper.handleImports();
  },

  /**
   * Elimina un registro a traves de un POST
   *
   * @param {Object} form Formulario que elimina el registro a través de la acción configurada
   * @param {String} manifiesto Nombre del registro a eliminar
   */
  eliminar(form, manifiesto) {
    let mensaje =
      "<p>¿Realmente deseas eliminar el Manifiesto <strong>" +
      manifiesto +
      "</strong>?</p><p>La acci&oacute;n no podr&aacute; ser revertida.</p>";
    FormHelper.confirm(form, mensaje);
  }
};
